import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';
import Router from 'react-router/Router'

import config from '../../config';
import bus from './libs/bus';
import history from './history';
import Route, { PrivateRoute, PublicRoute } from './components/Route';
import OnRoute from './components/OnRoute';

import DefaultLayout from './layouts/default/DefaultLayoutContainer';
import PluginLayout from './layouts/plugin/PluginLayoutContainer';
import Errors from './modules/Errors';
import WorkArea from './modules/WorkArea';
import Ebay from './modules/Ebay';
import Login from './modules/Login/Login.container';
import NotFound from './modules/NotFound/NotFound.container';
import Plugin from './modules/Plugin';

class App extends Component {
  constructor(props){
    super(props);
    this.handleRequestCompleted = this.handleRequestCompleted.bind(this);
  }
  componentDidMount(){
    bus.on('http-request-completed', this.handleRequestCompleted)
  }
  componentWillUnmount(){
    bus.off('handleRequestCompleted', this.handleRequestCompleted);

  }
  handleRequestCompleted(payload){
    const { dispatch } = this.props;
    const rateLimitRemaining = payload.data && payload.data.headers && payload.data.headers['x-ratelimit-remaining'];
    if(rateLimitRemaining){
      dispatch({
        type: 'RATE_LIMIT_REMAINING',
        payload: {
          rateLimitRemaining,
        },
      })
    }
  }
  onRoute(payload){
    const { dispatch } = this.props;
    dispatch({
      type: 'ROUTE',
      payload
    });
  }
  render() {
    const { loading } = this.props;

    // TODO: I could make the admin and the plugin a single app and just put a conditional here
    return (
      <Router history={history}>
        <OnRoute onRoute={(payload)=>this.onRoute(payload)}>
          <div className={config.appEnvironment === 'plugin' ? 'page-container plugin-container' : 'page-container'}>
            <Errors/>
            {config.appEnvironment === 'plugin' ? (
              <Switch>
                <PublicRoute path="/login" component={Login} page="login"/>
                <PrivateRoute layout={DefaultLayout} exact path="/" component={Plugin} page="plugin"/>
                <PrivateRoute component={NotFound}/>
              </Switch>
            ) : (
              <Switch>
                <PublicRoute path="/login" component={Login} page="login"/>
                <PublicRoute path="/2-factor-required" component={Login} page="login"/>
                <PrivateRoute layout={DefaultLayout} exact path="/" component={WorkArea} page="trades"/>
                <PrivateRoute layout={DefaultLayout} path="/workArea" component={WorkArea} page="workArea"/>
                <PrivateRoute layout={DefaultLayout} path="/ebay" component={Ebay} page="Ebay"/>
                <PrivateRoute layout={DefaultLayout} path="/ebay-auth" component={Ebay} page="Ebay"/>
                <PrivateRoute component={NotFound}/>
              </Switch>
            )}
            {loading && (
              <div className="loading-container primary callout">
                loading ...
              </div>
            )}
          </div>
        </OnRoute>
      </Router>
    );
  }
}

function mapStateToProps(state) {
  const { loaders } = state;
  return {
    loading: loaders.main,
  };
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/app/AppView.js